const { default: secureLocalStorage } = require("react-secure-storage");


export const getUserModulePermissions = () => {
  const user = JSON.parse(secureLocalStorage.getItem("authUser"));
  if (!user?.modules) return {};

  // Convert to an easier-to-use format: { 'ModuleName': ['View', 'Edit'] }
  const permissionsMap = {};

  user.modules.forEach((moduleWrapper) => {
    const moduleName = moduleWrapper.module?.moduleName;
    const operations = moduleWrapper.operations?.map((op) => op.operationName);
    if (moduleName && operations) {
      permissionsMap[moduleName] = operations;
    }
  });
  return permissionsMap;
  
};

export const hasPermission = (moduleName, operation) => {
  const permissions = getUserModulePermissions();
  return permissions[moduleName]?.includes(operation);
};

export const hasRolePermission = (roleId) => {
  const user = JSON.parse(secureLocalStorage.getItem("authUser"));
  const rolePermissions = user?.rolePermissionSummaries;
  return rolePermissions?.some((rp) => rp.id === roleId);
} 
